import React, { useCallback } from 'react';
import { useRouter } from 'next/router';

import {
  ProjectOtherActiveRaffle,
  YouWonRaffle,
} from 'api/raffle/raffle_detail';
import { useAppSelector } from 'store/hooks';
import CopyToClipboard from 'react-copy-to-clipboard';
import { successMsg } from '@/components/PageElement/SuccessMessage';
import { addressFormat } from 'lib/nicknameFormat';
import { CopyLeft } from 'lib/lucky-x-icons-2';

interface IActiveListProps {
  otherActiveList: ProjectOtherActiveRaffle[];
  ownList: YouWonRaffle[];
}

const ActiveList: React.FC<IActiveListProps> = ({
  otherActiveList,
  ownList,
}) => {
  const {
    raffleInfo: { project },
  } = useAppSelector((state) => state.raffleDetails);

  const scrollToTop = useCallback((vanity_url: string) => {
    setTimeout(() => {
      open(`/r/${vanity_url}`, '_self');
      const topEle = document.querySelector('#pageTop');
      topEle?.scrollTo(120, 0);
    }, 10);
  }, []);

  const ownnerListRender = useCallback(() => {
    if (ownList?.length !== 0 && !!ownList) {
      return (
        <div className="mt-8 text-2xl font-semibold text-neutral-100">
          <div className="mb-3 break-all">You won</div>
          <div className="grid grid-cols-1 gap-4 rounded-2xl border border-neutral-600 px-5 py-6">
            {ownList?.map((item, index) => (
              <div
                className="flex cursor-pointer flex-wrap items-center justify-between text-base font-normal"
                key={index}
              >
                <div className="flex items-center gap-2">
                  {item?.campaign?.logo ? (
                    <img
                      src={item?.campaign?.logo}
                      className="h-6 w-6 shrink-0 rounded-full"
                      alt=""
                      onError={(e: any) => {
                        e.target.src =
                          'https://s.luckygo.io/luckybuy/img/detailAvatarImg.png';
                      }}
                    />
                  ) : (
                    <div className="h-6 w-6 shrink-0 rounded-full bg-neutral-400 text-center text-sm leading-6 text-neutral-100">
                      {item?.campaign?.name?.slice(0, 1)}
                    </div>
                  )}
                  <div
                    className="break-all text-base font-normal underline"
                    onClick={() => {
                      scrollToTop(item?.vanity_url as string);
                    }}
                  >
                    {item?.name}
                  </div>
                </div>

                <CopyToClipboard
                  text={item?.my_entry?.mint_wallet}
                  onCopy={() => {
                    successMsg('Copied to clipboard');
                  }}
                >
                  <div className="flex items-center gap-2">
                    <div className="text-base font-medium underline">
                      {addressFormat(item?.my_entry?.mint_wallet)}
                    </div>
                    <CopyLeft size={24} className="text-neutral-400" />
                  </div>
                </CopyToClipboard>
              </div>
            ))}
          </div>
        </div>
      );
    }
  }, [ownList, scrollToTop]);

  const activeListRender = useCallback(() => {
    if (otherActiveList?.length !== 0 && !!otherActiveList) {
      return (
        <div className="mt-8 text-2xl font-semibold text-neutral-100">
          <div className="mb-3 break-all">
            Other active {project?.name} raffles
          </div>
          <div className="grid grid-cols-1 gap-4 rounded-2xl border border-neutral-600 px-5 py-6">
            {otherActiveList?.map((item, index) => (
              <div
                className="flex cursor-pointer items-center justify-between text-base font-normal"
                key={index}
              >
                <div className="flex items-center gap-2">
                  {item?.campaign?.logo ? (
                    <img
                      src={item?.campaign?.logo}
                      className="h-6 w-6 shrink-0 rounded-full"
                      alt=""
                      onError={(e: any) => {
                        e.target.src =
                          'https://s.luckygo.io/luckybuy/img/detailAvatarImg.png';
                      }}
                    />
                  ) : (
                    <div className="h-6 w-6 shrink-0 rounded-full bg-neutral-400 text-center text-sm leading-6 text-neutral-100">
                      {item?.campaign?.name?.slice(0, 1)}
                    </div>
                  )}
                  <div
                    className="max-w-[120px] truncate text-base font-normal underline sm:max-w-[200px] md:max-w-[300px] lg:max-w-[120px] 2xl:max-w-[200px]"
                    onClick={() => {
                      scrollToTop(item?.vanity_url as string);
                    }}
                  >
                    {item?.name}
                  </div>
                </div>

                {!!item?.my_entry && (
                  <div className="text-base font-medium underline">
                    {addressFormat(item?.my_entry?.mint_wallet)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      );
    }
  }, [otherActiveList, project?.name, scrollToTop]);

  return (
    <div>
      {ownnerListRender()}

      {activeListRender()}
    </div>
  );
};

export default ActiveList;
